import { Spinner } from "@chakra-ui/react";
import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";

const SafeIFrame = ({ url }) => {
  const [loading, setLoading] = useState(true);
  const [isSuccess, setIsSuccess] = useState(true);
  const [isSafari, setIsSafari] = useState(false);

  // Detect Safari and handle accordingly
  useEffect(() => {
    const safariDetected = /^((?!chrome|android).)*safari/i.test(
      navigator.userAgent,
    );
    setIsSafari(safariDetected);

    // if (safariDetected) {
    //   // For Safari, show a delayed message about 3D content
    //   const timer = setTimeout(() => {
    //     toast.info("Safari users: If 3D content doesn't load, click 'Open in New Tab' below", {
    //       autoClose: 5000
    //     });
    //   }, 3000);

    //   return () => clearTimeout(timer);
    // }
  }, []);

  return (
    <div className="mb-4 relative rounded-2xl h-[500px] overflow-hidden">
      {loading && (
        <div className="absolute top-0 left-0 bg-gray-200 w-full h-full flex items-center justify-center text-teal-600">
          <Spinner size={"lg"} />
        </div>
      )}

      {isSuccess ? (
        <div className="relative h-full">
          <iframe
            src={url}
            width="100%"
            height="100%"
            onLoad={() => {
              setIsSuccess(true);
              setLoading(false);
              //   toast.success("Preview Loaded Successfully");
            }}
            onError={() => {
              setIsSuccess(false);
              setLoading(false);
            }}
            sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-pointer-lock"
            allow="fullscreen; accelerometer; gyroscope; magnetometer; vr; xr-spatial-tracking"
            referrerPolicy="unsafe-url"
            allowFullScreen={true}
            webkitAllowFullScreen={true}
            mozAllowFullScreen={true}
          />

          {/* Safari fallback button */}
          {isSafari && (
            <div className="absolute bottom-4 right-4">
              <button
                onClick={() => window.open(url, "_blank")}
                className="flex items-center gap-2 px-4 py-2 bg-teal-500/90 backdrop-blur-sm text-white rounded-lg hover:bg-teal-600 transition-colors duration-200 shadow-lg text-sm"
                title="Open in new tab if 3D content doesn't load"
              >
                <Icon icon="mdi:open-in-new" className="w-4 h-4" />
                <span>Open in New Tab</span>
              </button>
            </div>
          )}
        </div>
      ) : (
        <div
          className="flex flex-col items-center justify-center h-full cursor-pointer bg-teal-50 hover:bg-teal-100 transition-all duration-300 rounded-lg shadow-md p-6"
          onClick={() => window.open(url, "_blank")}
        >
          <Icon icon={"ph:mask-sad-thin"} color="#0694a2" width={"40px"} />
          <p className="text-teal-600 font-semibold text-lg mb-2">
            Unable to Load 3D Preview
          </p>
          {isSafari && (
            <p className="text-teal-500 text-sm mb-4 text-center">
              Safari requires opening Matterport content in a new tab
            </p>
          )}
          <button className="flex items-center gap-2 px-5 py-2.5 bg-teal-500 text-white rounded-full hover:bg-teal-600 transition-colors duration-200 shadow-sm">
            <Icon icon="mdi:open-in-new" className="w-5 h-5" />
            <span>Open in New Tab</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default SafeIFrame;
